const StatoAttivazione = {
  Incompleto: 1,
  RichiestaPendente: 2,
  Attivo: 3,
  Disdetto: 4,
  Sospeso: 5,
};

export default StatoAttivazione;
